import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/RecoverMemberNumberDef';

const autoGenerateSuccess = (value: string, birthDate: string) => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body:
        value.indexOf('@') < 0
          ? {
              birthDate,
              document: {
                type: 'CPF',
                value,
              },
            }
          : {
              birthDate,
              email: value,
            },
    },
    configResponse: {
      status: 200,
      data: {
        memberNumber: '468115465',
      },
      headers: {},
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessCPF = autoGenerateSuccess(
  MocksDef.DOCUMENT_TYPE.CPF,
  MocksDef.BIRTHDATE_YYYY_MM_DD,
);
const autoGenerateSuccessEMAIL = autoGenerateSuccess(
  MocksDef.EMAIL,
  MocksDef.BIRTHDATE_YYYY_MM_DD,
);

const generatedSuccessMocks = [
  autoGenerateSuccessCPF,
  autoGenerateSuccessEMAIL,
];

const autoGenerate = (login: string, birthDate: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const body =
        login.indexOf('@') < 0
          ? {
              birthDate: `${birthDate.slice(0, -1)}${index}`,
              document: {
                type: 'CPF',
                value: login,
              },
            }
          : {
              birthDate: `${birthDate.slice(0, -1)}${index}`,
              email: login,
            };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateErrorsMock = () => {
  const responseCPF = autoGenerate(
    MocksDef.DOCUMENT_TYPE.CPF,
    MocksDef.BIRTHDATE_YYYY_MM_DD,
  );
  const responseEMAIL = autoGenerate(
    MocksDef.EMAIL,
    MocksDef.BIRTHDATE_YYYY_MM_DD,
  );
  return [...responseCPF, ...responseEMAIL];
};

const errorsGenerated = autoGenerateErrorsMock();

const RecoverMemberNumber = [...generatedSuccessMocks, ...errorsGenerated];
export default RecoverMemberNumber;
